import { render, staticRenderFns } from "./ListPayouts.vue?vue&type=template&id=12039d52&scoped=true"
import script from "./ListPayouts.vue?vue&type=script&lang=ts"
export * from "./ListPayouts.vue?vue&type=script&lang=ts"
import style0 from "./ListPayouts.vue?vue&type=style&index=0&id=12039d52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12039d52",
  null
  
)

export default component.exports